export const createZillowUrl = (address, city, state) => {
    const fullAddress = `${address}, ${city}, ${state}`;
    return `https://www.zillow.com/homes/${encodeURIComponent(fullAddress)}`;
  };
  
  export const createFullAddress = (address, city, state) => {
    return `${address}, ${city}, ${state}`;
  };
  
  export const handleAddressClick = (e, address, city, state, setSelectedAddress, setMapSidebarOpen) => {
    e.stopPropagation(); // Prevent row expansion
    const fullAddress = createFullAddress(address, city, state);
    setSelectedAddress(fullAddress);
    setMapSidebarOpen(true);
  };
  
  export const handleZillowClick = (e, address, city, state, setZillowUrl, setZillowPropertyAddress, setZillowModalOpen) => {
    e.stopPropagation(); // Prevent row expansion
    const fullAddress = createFullAddress(address, city, state);
    const zillowLink = createZillowUrl(address, city, state);
    setZillowUrl(zillowLink);
    setZillowPropertyAddress(fullAddress);
    setZillowModalOpen(true);
  };
  
  export const handlePropertyDetailsClick = (e, listing, setSelectedPropertyForDetails, setPropertyDetailsModalOpen) => {
    e.stopPropagation(); // Prevent row expansion
    setSelectedPropertyForDetails(listing);
    setPropertyDetailsModalOpen(true);
  };